<p-dialog
  header="Sesión inactiva"
  [visible]="visible()"
  (visibleChange)="visible.set($event)"
  [modal]="true"
  [closable]="false"
  [style]="{width:'400px'}">

  <p>
    Tu sesión expirará en
    <b>{{countdown()}}</b>
    segundos.
    <br><br>
    ¿Deseas continuar?
  </p>

  <ng-template pTemplate="footer">

    <p-button
      label="Continuar"
      icon="pi pi-check"
      (click)="continueSession()">
    </p-button>

    <p-button
      label="Salir"
      severity="danger"
      icon="pi pi-sign-out"
      (click)="logout()">
    </p-button>

  </ng-template>

</p-dialog>
